import { useTranslation } from "react-i18next";

export default function ChatsPage() {
  const { t } = useTranslation("sidebar");

  return <title>{`${t("conversations")} - Ximly`}</title>;
}
